import { render, staticRenderFns } from "./NewCapacityType.vue?vue&type=template&id=2527d57d&scoped=true&"
import script from "./NewCapacityType.vue?vue&type=script&lang=js&"
export * from "./NewCapacityType.vue?vue&type=script&lang=js&"
import style0 from "./NewCapacityType.vue?vue&type=style&index=0&id=2527d57d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527d57d",
  null
  
)

export default component.exports